import React from 'react'

export default function FaceFeature({ scaleX, fill, outline, verticalOffset }) {
  return (
    <g transform={`scale(${scaleX},1) translate(0,${verticalOffset})`} fill="none">
      <path
        d="M50.4199 8.04016C50.4199 8.04016 49.5399 19.5402 46.0199 27.9102C43.2699 34.4502 40.5199 36.8302 40.5199 36.8302C40.5199 36.8302 38.8699 32.6502 37.3799 31.4902C35.9999 30.4202 26.6299 27.6102 26.6299 27.6102C26.6299 27.6102 17.0899 30.4202 15.7099 31.4902C14.2199 32.6502 12.5699 36.8302 12.5699 36.8302C12.5699 36.8302 9.81993 34.4502 7.06993 27.9102C3.54993 19.5402 2.66993 8.04016 2.66993 8.04016C-3.83007 41.3402 12.5799 52.5702 12.5799 52.5702C13.8999 39.3602 18.5699 34.6902 18.5699 34.6902C21.8199 35.9502 30.9599 35.8402 34.5199 34.6902C34.5199 34.6902 39.1899 39.3602 40.5099 52.5702C40.5099 52.5702 56.9199 41.3402 50.4199 8.04016Z"
        fill={fill}
        stroke={outline}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M16.0799 31.5402C16.0799 31.5402 12.4499 34.8402 9.35986 50.0402"
        stroke={outline}
        strokeMiterlimit="10"
      />
      <path
        d="M9.92008 33.8502C9.92008 33.8502 6.40008 38.4702 5.08008 42.2202"
        stroke={outline}
        strokeWidth="0.5"
        strokeMiterlimit="10"
      />
      <path
        d="M8.59996 31.5402C8.59996 31.5402 4.85996 34.6202 3.20996 37.8202"
        stroke={outline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M6.1698 26.8102C6.1698 26.8102 3.5298 28.2402 1.5498 30.1102"
        stroke={outline}
        strokeWidth="0.5"
        strokeMiterlimit="10"
      />
      <path
        d="M5.07 23.5002C5.07 23.5002 1.99 24.7102 1 25.4802"
        stroke={outline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M23.4601 29.0101C23.4601 29.0101 22.4701 31.3202 21.8101 34.7302"
        stroke={outline}
        strokeWidth="0.5"
        strokeMiterlimit="10"
      />
      <path
        d="M25.6599 28.3502C25.6599 28.3502 25.2199 31.4302 25.1099 35.0702"
        stroke={outline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M21.48 29.7802C21.48 29.7802 15.2 35.9502 13.77 42.5502"
        stroke={outline}
        strokeWidth="0.5"
        strokeMiterlimit="10"
      />
      <path d="M37 31.5402C37 31.5402 40.75 35.5002 43.72 50.0402" stroke={outline} strokeMiterlimit="10" />
      <path
        d="M43.1699 33.8502C43.1699 33.8502 46.6899 38.4702 48.0099 42.2202"
        stroke={outline}
        strokeWidth="0.5"
        strokeMiterlimit="10"
      />
      <path
        d="M44.4897 31.5402C44.4897 31.5402 48.2297 34.6202 49.8797 37.8202"
        stroke={outline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M46.9102 26.8102C46.9102 26.8102 49.5502 28.2402 51.5302 30.1102"
        stroke={outline}
        strokeWidth="0.5"
        strokeMiterlimit="10"
      />
      <path
        d="M48.0098 23.5002C48.0098 23.5002 51.0898 24.7102 52.0798 25.4802"
        stroke={outline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M29.6201 29.0101C29.6201 29.0101 30.6101 31.3202 31.2701 34.7302"
        stroke={outline}
        strokeWidth="0.5"
        strokeMiterlimit="10"
      />
      <path
        d="M27.4199 28.3502C27.4199 28.3502 27.8599 31.4302 27.9699 35.0702"
        stroke={outline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M31.6099 29.7802C31.6099 29.7802 37.8899 35.9502 39.3199 42.5502"
        stroke={outline}
        strokeWidth="0.5"
        strokeMiterlimit="10"
      />
    </g>
  )
}
